
import { User } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeroSection = () => {
  const { t } = useTranslation('individuals');

  return (
    <section className="relative min-h-[90vh] flex items-center">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/8),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/4),transparent)]" />
        <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/5),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/3),transparent)]" />
      </div>
      
      <div className="container-custom relative z-10 py-24">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-blue/10 dark:bg-brand-blue/5 text-brand-blue dark:text-brand-orange mb-8">
            <User className="w-5 h-5" />
            <span className="text-sm font-medium">{t('badge')}</span>
          </div>
          
          <h1 className="text-5xl sm:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange leading-[1.2] pb-4">
            {t('vae.title')}
          </h1>
          
          <p className="text-xl text-muted-foreground mb-12 max-w-2xl mx-auto">
            {t('vae.description')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/search" 
              className="inline-flex items-center px-6 py-3 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              {t('cta.explore')}
            </a>
            <Link
              to="/contact" 
              className="inline-flex items-center px-6 py-3 rounded-lg border-2 border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              {t('cta.contact')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
